<template>
  <!-- 题目标签管理 列表页 -->
    <div class="board">
        <div v-hasPermi="['questionBank:tag:list']">
            <div class="title">
                <span class="name">{{ questionTagTextConfig.title }}</span>
                <div>
                    <el-button v-hasPermi="['questionBank:tagGroup:add']" type="primary"
                               @click="groupDialogVisible = true">
                        {{ questionTagTextConfig.addGroup }}
                    </el-button>
                    <el-button v-hasPermi="['questionBank:tag:add']" type="primary" @click="tagDialogVisible = true">
                        {{ questionTagTextConfig.add }}
                    </el-button>
                </div>
            </div>
            <el-form :inline="true" :model="form" ref="form">
                <el-form-item>
                    <el-input v-model.trim="form.tagGroup" clearable
                              :placeholder="searchTextConfig.tagGroup"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model.trim="form.tag" clearable :placeholder="searchTextConfig.tag"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="form.status" clearable :placeholder="searchTextConfig.status">
                        <el-option v-for="item in statusOptions" :key="item.value" :label="item.label"
                                   :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search">{{ searchTextConfig.select }}</el-button>
                    <el-button @click="reset">{{ searchTextConfig.reset }}</el-button>
                </el-form-item>
            </el-form>
            <p class="info">
                <span>已选：<i>{{ selectRow.length }}</i>/{{ tags }} </span>
                <el-button
                        v-hasPermi="['questionBank:tag:delete']"
                        :disabled="!selectRow.length"
                        @click="batchDelete"
                        type="danger"
                        size="mini"
                        style="margin-left:10px">
                    {{ batchTextConfig.delete.name }}
                </el-button>
                <el-button
                        v-hasPermi="['questionBank:tag:update']"
                        :disabled="!selectRow.length"
                        @click="setGroupDialogVisible = true"
                        type="primary"
                        size="mini">
                    {{ batchTextConfig.setGroup.name }}
                </el-button>
            </p>
            <p class="treeHead">
                <span>
                    <el-checkbox
                            :indeterminate="isIndeterminate"
                            v-model="flag"
                            @change="handleCheckAllChange">
                        {{ treeTextConfig.tag }}
                    </el-checkbox>
                </span>
                <span>{{ treeTextConfig.update }}</span>
                <span>{{ treeTextConfig.status }}</span>
                <span>{{ treeTextConfig.operate }}</span>
            </p>
            <el-tree :data="tableData" ref="elTree" :indent="50" @check="getCheckedNodes" show-checkbox node-key="key"
                     default-expand-all :expand-on-click-node="false">
                <span class="custom-tree-node" slot-scope="{ data }">
                    <span>
                        {{ data.depth ? data.name : '' }}
                        <el-tag type="info" v-if="!data.depth" style="margin-left:5px">
                            {{ data.name }}
                        </el-tag>
                    </span>
                    <span>
                        <p>{{ data.updated_by_username }}</p>
                        <p class="updateDate">{{ data.updated_at|formatTime }}</p>
                    </span>
                    <span v-if="!data.depth">
                        <el-tag v-if="data.status == 0" type="info">{{ treeTextConfig.use.false }}</el-tag>
                        <el-tag v-else>{{ treeTextConfig.use.true }}</el-tag>
                    </span>
                    <span v-else></span>
                    <span>
                        <el-button v-hasPermi="[!data.depth?'questionBank:tag:update':'questionBank:tagGroup:update']"
                                   size="mini" plain type="primary"
                                   @click="edit(data)">
                            {{ treeButtonTextConfig.edit.name }}
                        </el-button>
                        <el-button v-hasPermi="['questionBank:tagGroup:delete']"
                                   v-if="data.depth && data.children.length" size="mini" plain type="danger"
                                   @click="delGroupDialogVisible = true, delForm.group_id = data.id">
                            {{ deleteAllTextConfig.name }}
                        </el-button>
                        <el-button v-hasPermi="['questionBank:tagGroup:delete']"
                                   v-else-if="data.depth && !data.children.length" size="mini" plain type="danger"
                                   @click="delet(data)">
                            {{ treeButtonTextConfig.deleteGroup.name }}
                        </el-button>
                        <el-button v-hasPermi="['questionBank:tag:delete']" v-else size="mini" plain type="danger"
                                   :disabled="data.status==1"
                                   @click="delet(data)">
                            {{ treeButtonTextConfig.deleteTag.name }}
                        </el-button>
                    </span>
                </span>
            </el-tree>
            <el-dialog v-if="delGroupDialogVisible" :title="deleteAllTextConfig.title" :visible.sync="delGroupDialogVisible"
                       width="500px" @close="delGroupClose" destroy-on-close :close-on-click-modal="false"
                       :close-on-press-escape="false">
                <el-form :model="delForm" label-width="100px">
                    <el-form-item :label="deleteAllTextConfig.range.name">
                        <el-radio-group v-model="delForm.range.name" style="margin-left:60px">
                            <el-radio label="keep" style="margin-right:52px">{{ deleteAllTextConfig.range.tag }}</el-radio>
                            <el-radio label="delete">{{ deleteAllTextConfig.range.tagAndGroup }}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="delGroupClose()">{{ deleteAllTextConfig.cancel }}</el-button>
                    <el-button type="primary" @click="deletGroup()">{{ deleteAllTextConfig.ok }}</el-button>
                </span>
            </el-dialog>
            <edit-tag-dialog :row="row" :selectRow="selectRow" :groupShow.sync="groupDialogVisible"
                             :tagShow.sync="tagDialogVisible" :setShow.sync="setGroupDialogVisible"
                             @close="close"></edit-tag-dialog>
        </div>
    </div>
</template>

<script>
import editTagDialog from './dialog/editTag.vue'

export default {
    components: {
        editTagDialog
    },
    data() {
        return {
            height: 250,
            form: {
                keyword: '',
                tagGroup: '',
                tag: '',
                status: ''
            },
            delGroupDialogVisible: false,
            delForm: {
                range: {
                    name: 'keep',
                    tag: '仅标签'
                },
                group_id: null
            },
            statusOptions: [{
                label: this.$store.state.global.textConfig.backend.questionTag.tree.use.false,
                value: '0'
            }, {
                label: this.$store.state.global.textConfig.backend.questionTag.tree.use.true,
                value: '1'
            }],
            tags: 0,
            selectRow: [],
            InitialData: [],
            tableData: [],
            groupDialogVisible: false,
            tagDialogVisible: false,
            setGroupDialogVisible: false,
            row: null,
            tagGroup: [],
            flag: false,
            isIndeterminate: false,
        }
    },
    computed: {
        questionTagTextConfig() {
            return this.$store.state.global.textConfig.backend.questionTag
        },
        searchTextConfig() {
            return this.questionTagTextConfig.search
        },
        batchTextConfig() {
            return this.questionTagTextConfig.batch
        },
        treeTextConfig() {
            return this.questionTagTextConfig.tree
        },
        treeButtonTextConfig() {
            return this.treeTextConfig.button
        },
        deleteAllTextConfig() {
            return this.treeButtonTextConfig.deleteAll
        },
    },
    watch: {
        tableData() {
            if (this.tableData.length == 0) {
                this.height = 120
            } else {
                this.updateHeight()
            }
        }
    },
    mounted() {
        const that = this;
        setTimeout(() => {
            that.updateHeight()
        }, 200);
        window.onresize = () => {
            that.updateHeight()
        };
        this.getData()
        this.search()
    },
    methods: {
        handleCheckAllChange(val) {
            if (val) {
                this.$refs.elTree.setCheckedNodes(this.tableData);
                this.getCheckedNodes()
            } else {
                this.$refs.elTree.setCheckedKeys([]);
                this.selectRow = []
            }
            this.isIndeterminate = false;
            this.flag = val
        },
        getCheckedNodes() {
            this.selectRow = []
            let arr = this.$refs.elTree.getCheckedNodes()
            for (let i = 0; i < arr.length; i++) {
                const e = arr[i];
                if (e.depth != 1) {
                    this.selectRow.push(e)
                }
            }
            if (this.tags == this.selectRow.length) {
                this.isIndeterminate = false;
                this.flag = true
            } else {
                if (this.selectRow.length > 0) {
                    this.isIndeterminate = true;
                } else {
                    this.isIndeterminate = false;
                }
                this.flag = false
            }
        },
        getData() {
            this.$store.dispatch("getQuestionTagList").then(res => {
                this.InitialData = []
                if (res) {
                    for (let i = 0; i < res.data.length; i++) {
                        const e = res.data[i];
                        if (i != (res.data.length - 1)) {
                            this.InitialData.push(e)
                        } else {
                            this.InitialData.push(...e.children)
                        }
                    }
                    this.tableData = JSON.parse(JSON.stringify(this.InitialData))
                    this.search()
                }
            });
            this.$store.dispatch("getQuestionTagGroupList").then(res => {
                this.tagGroup = res.data
            });
        },
        search() {
            if (!this.form.tag && !this.form.tagGroup && !this.form.status) {
                this.tableData = JSON.parse(JSON.stringify(this.InitialData))
            } else {
                this.tableData = JSON.parse(JSON.stringify(this.InitialData))
                for (let i = 0; i < this.tableData.length; i++) {
                    const e = this.tableData[i];
                    let patt = true, result = true
                    if (this.form.tagGroup) {
                        patt = new RegExp(this.form.tagGroup, 'i');
                        result = patt.test(e.name);
                    }
                    if (e.depth) {
                        if (e.children) {
                            if (!result) {
                                this.tableData.splice(i, 1);
                                i--
                            }
                            if (this.form.tag) {
                                for (let j = 0; j < e.children.length; j++) {
                                    const f = e.children[j];
                                    let patt2 = new RegExp(this.form.tag, 'i');
                                    let result2 = patt2.test(f.name);
                                    if (!result2) {
                                        e.children.splice(j, 1);
                                        j--
                                    } else {
                                        if (this.form.status != '' && this.form.status != f.status) {
                                            e.children.splice(j, 1);
                                            j--
                                        }
                                    }
                                }
                            } else {
                                for (let j = 0; j < e.children.length; j++) {
                                    const f = e.children[j];
                                    if (this.form.status != '' && this.form.status != f.status) {
                                        e.children.splice(j, 1);
                                        j--
                                    }
                                }
                            }
                        } else {
                            if (!result) {
                                this.tableData.splice(i, 1);
                                i--
                            }
                        }
                    } else {
                        if (this.form.tagGroup.length || !result || (this.form.status != '' && this.form.status != e.status)) {
                            this.tableData.splice(i, 1);
                            i--
                        }
                    }
                }
            }
            setTimeout(() => {
                this.tagNum()
                this.$refs.elTree.setCheckedKeys([]);
                this.flag = false
                this.isIndeterminate = false
                this.selectRow = []
            }, 200);
        },
        reset() {
            this.form.tagGroup = ''
            this.form.tag = ''
            this.form.status = ''
            this.tableData = JSON.parse(JSON.stringify(this.InitialData))
            this.tagNum()
        },
        batchDelete() {
            let ids = []
            for (let i = 0; i < this.selectRow.length; i++) {
                const e = this.selectRow[i];
                if (e.status == 0) {
                    ids.push(e.id)
                }
            }
            let batchDeleteTextConfig = this.batchTextConfig.delete
            if (ids.length > 0) {
                this.$confirm(batchDeleteTextConfig.message.signMix(this.selectRow.length), batchDeleteTextConfig.title, {
                    confirmButtonText: batchDeleteTextConfig.ok,
                    cancelButtonText: batchDeleteTextConfig.cancel,
                    type: 'warning'
                }).then(() => {
                    this.$store.dispatch("deleteQuestionTag", ids.join(',')).then(res => {
                        if (res.status == 200) {
                            let str = this.selectRow.length != ids.length ? batchDeleteTextConfig.skipSuccess : batchDeleteTextConfig.success
                            this.$message({
                                message: str,
                                type: 'success'
                            });
                            this.getData()
                            this.search()
                        }
                    });
                })
            } else {
                this.$message({
                    message: batchDeleteTextConfig.error.signMix(this.selectRow.length),
                    type: 'warning'
                });
            }
        },
        edit(row) {
            this.row = row
            if (row.depth) {
                this.groupDialogVisible = true
            } else {
                this.tagDialogVisible = true
            }

        },
        delGroupClose() {
            this.delGroupDialogVisible = false
            this.delForm = {
                range: {
                    name: 'keep',
                    tag: '仅标签'
                },
                group_id: null
            }
        },
        deletGroup() {
            this.$store.dispatch("deleteQuestionTagGroup", {
                range: this.delForm.range.name,
                group_id: this.delForm.group_id
            }).then(res => {
                if (res.status == 200) {
                    this.$message({
                        message: this.deleteAllTextConfig.message,
                        type: 'success'
                    });
                    this.getData()
                    this.search()
                }
            });
            this.delGroupClose()
        },
        delet(row) {
            if (row.depth) {
                let data = {
                    range: 'keep',
                    group_id: row.id
                }
                let deleteGroupTextConfig = this.treeButtonTextConfig.deleteGroup
                this.$confirm(deleteGroupTextConfig.message, deleteGroupTextConfig.title, {
                    confirmButtonText: deleteGroupTextConfig.ok,
                    cancelButtonText: deleteGroupTextConfig.cancel,
                    type: 'warning'
                }).then(() => {
                    this.$store.dispatch("deleteQuestionTagGroup", data).then(res => {
                        if (res.status == 200) {
                            this.$message({
                                message: deleteGroupTextConfig.success,
                                type: 'success'
                            });
                            this.getData()
                            this.search()
                        }
                    });
                })
            } else {
                let deleteTagTextConfig = this.treeButtonTextConfig.deleteTag
                this.$confirm(deleteTagTextConfig.message, deleteTagTextConfig.title, {
                    confirmButtonText: deleteTagTextConfig.ok,
                    cancelButtonText: deleteTagTextConfig.cancel,
                    type: 'warning'
                }).then(() => {
                    this.$store.dispatch("deleteQuestionTag", row.id).then(res => {
                        if (res.status == 200) {
                            this.$message({
                                message: deleteTagTextConfig.success,
                                type: 'success'
                            });
                            this.getData()
                            this.search()
                        }
                    });
                })
            }
        },
        close(data) {
            this.groupDialogVisible = data
            this.tagDialogVisible = data
            this.setGroupDialogVisible = false
            this.getData()
        },
        tagNum() {
            this.tags = 0
            this.$refs.elTree.data.map((items) => {
                if (!items.depth) {
                    this.tags += 1
                } else {
                    if (items.children) {
                        items.children.map((item) => {
                            this.tags += 1
                        });
                    }
                }
            });
        },
        updateHeight() {
            if (document.getElementsByClassName('el-form')[0]) {
                this.height = document.getElementsByClassName('board')[0].clientHeight - document.getElementsByClassName('el-form')[0].clientHeight - 150
                this.height = this.height < 460 ? 460 : this.height
            }
        }
    }
}
</script>

<style scoped>
.info {
    color: #555;
    font-size: 15px;
    margin-bottom: 12px;
}

.info span {
    color: #C0C4CC;
    margin-left: 12px;
}

.info i {
    color: #555;
}

.el-tree {
    border-top: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
    height: calc(100% - 240px);
    overflow: auto;
}

.el-tree >>> .el-tree-node__content {
    height: 50px;
}

.el-tree >>> .custom-tree-node {
    display: block;
    width: 100%;
    position: relative;
}

.el-tree >>> .custom-tree-node > span:first-child {
    font-size: 13px;
}

.el-tree >>> .custom-tree-node > span:last-child {
    position: absolute;
    right: 10px;
    bottom: -4px;
}

.el-tree >>> .custom-tree-node > span:nth-child(2) {
    position: absolute;
    right: 310px;
    bottom: -3px;
}

.el-tree >>> .custom-tree-node > span:nth-child(3) {
    position: absolute;
    right: 190px;
    width: 56px;
}

.el-tree >>> .el-tree-node {
    border-top: 1px solid #ebeef5;
}

.board >>> .el-tree > .el-tree-node:first-child {
    border-top: 0;
}

.updateDate {
    font-size: 12px;
    color: #bbb;
    line-height: 12px;
}

.treeHead {
    color: #909399;
    font-weight: 600;
    padding-left: 23px;
    position: relative;
    line-height: 50px;
}

.treeHead >>> .el-checkbox__label {
    color: #909399 !important;
    font-weight: 600;
}

.treeHead span:last-child {
    position: absolute;
    right: 110px;
}

.treeHead span:nth-child(3) {
    position: absolute;
    right: 196px;
}

.treeHead span:nth-child(2) {
    position: absolute;
    right: 377px;
}
</style>